import { FormLabel, Input, InputProps, Stack } from '@chakra-ui/react';
import { useCurrentColors } from '../../hooks/UseCurrentColors/UseCurrentColors';

export interface CanopyInputProps extends InputProps {
    label?: string;
    type?: string;
}
export default function CanopyInput({
    children,
    fontSize = 'lg',
    _hover,
    _focus,
    _active,
    ...props
}: CanopyInputProps) {
    const currentColors = useCurrentColors();

    return (
        <Stack
            width="100%"
            marginBottom="0px">
            {props.label ? (
                <FormLabel
                    p="0px"
                    htmlFor={props.id}
                    color={currentColors.brand['10']}
                    fontSize={fontSize}
                    fontWeight="bold"
                    lineHeight="unset"
                    mb="7px">
                    {props.label}
                </FormLabel>
            ) : null}
            <Input
                height="45px"
                border="1px"
                borderRadius="4px"
                color={currentColors.brand['300']}
                borderColor={currentColors.brand['600']}
                backgroundColor={currentColors.brand['900']}
                p={'10px'}
                fontSize={fontSize}
                _hover={{
                    color: currentColors.inputText,
                    borderColor: currentColors.brand['600'],
                    backgroundColor: currentColors.brand['900'],
                    ..._hover,
                }}
                _focus={{
                    color: currentColors.inputText,
                    outline: 'none',
                    boxShadow: 'none',
                    borderColor: currentColors.brand['600'],
                    backgroundColor: currentColors.brand['900'],
                    ..._focus,
                }}
                _active={{
                    color: currentColors.inputText,
                    backgroundColor: currentColors.brand['900'],
                    borderColor: currentColors.brand['600'],
                    ..._active,
                }}
                {...props}
            />
        </Stack>
    );
}
